import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=96e8031a&scoped=true&"
import script from "./NewsBlock.vue?vue&type=script&lang=js&"
export * from "./NewsBlock.vue?vue&type=script&lang=js&"
import style0 from "./NewsBlock.vue?vue&type=style&index=0&id=96e8031a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8031a",
  null
  
)

export default component.exports